import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import ActivateIcon from '@mui/icons-material/CheckCircle';
import VisibilityIcon from '@mui/icons-material/Visibility';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { saveData, getData, openDB } from '../../../utils/db';
import { fetchData, deleteData, activateData } from '../../../apiService';
import CopyrightIcon from '@mui/icons-material/Copyright';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';

function RoleIndex() {

  const { isAuthenticated, companyId, isSuperAdmin, permissions, token, logout } = useAuth();
  const [data, setData] = useState([]);
  const [deleteItemId, setDeleteItemId] = useState(null); // Track the item ID to delete
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const hasCreateAdministrationPermission = permissions.includes('Create Administration');
  const hasEditAdministrationPermission = permissions.includes('Edit Administration');
  const hasDeleteAdministrationPermission = permissions.includes('Delete Administration');

  useEffect(() => {
    //Check if the token is expired
    if (isAuthenticated && tokenIsExpired(token)) {
      // Token is expired, log out the user
      logout();
      return;
    }

  }, [isAuthenticated, companyId, token, logout]);

  useEffect(() => {
    fetchtableData();
  }, []);

  const fetchtableData = async () => {
    fetchData('RoleApi', `/${companyId}`, token)//, token
      .then((response) => {
        if (response.responseCode == '1111') {
          console.log(response);
          setData(response.response_data);
        }
      })
      .catch((error) => {
        console.error('Error fetching Role Details:', error);
      });
  };

  const handleDelete = async () => {
    deleteData('RoleApi', `${deleteItemId}`, token)
      .then((response) => {
        fetchtableData(); // Refresh data after deletion
        setDeleteItemId(null); // Reset the item ID
        setConfirmDialogOpen(false); // Close the dialog
      })
      .catch((error) => {
        console.error('Error deleting record:', error);
      });
  };

  const handleActivate = (itemId) => {
    activateData('RoleApi', `${itemId}`, token)
      .then((response) => {
        fetchtableData(); // Refresh data after deletion
      })
      .catch((error) => {
        // Handle errors for the activation request
      });
  };

  const openConfirmDialog = (itemId) => {
    setDeleteItemId(itemId);
    setConfirmDialogOpen(true);
  };

  const closeConfirmDialog = () => {
    setDeleteItemId(null);
    setConfirmDialogOpen(false);
  };

  return (
    <div className="w-full max-w-sm container mt-6 mx-auto">
      <div className='w-full mb-2 flex'>
        <h6
          className="uppercase tracking-wide text-black flex-grow linkcolor"
          style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}
        > ROLE </h6>
      </div>

      <div className='w-full mb-5 flex' style={{ maxHeight: '550px', overflowY: 'auto' }}>
        <TableContainer component={Paper}>
          <Table>
            <TableHead sx={{ backgroundColor: '#5F8670' }}>
              <TableRow>
                <TableCell
                  style={{
                    background: 'linear-gradient(to right, #033316ff, #044b3fff)', borderRadius: '5px', color: 'white',
                    fontWeight: '600', fontSize: '12px', border: '1px solid #ccc', textAlign: 'center', position: 'sticky',
                    top: 0, zIndex: 10, whiteSpace: 'nowrap', padding: '3px', borderRadius: '4px', textTransform: 'uppercase', width: '3%'
                  }}>
                  Sl.No
                </TableCell>
                <TableCell
                  style={{
                    background: 'linear-gradient(to right, #033316ff, #044b3fff)', borderRadius: '5px', color: 'white',
                    fontWeight: '600', fontSize: '12px', border: '1px solid #ccc', textAlign: 'center', position: 'sticky',
                    top: 0, zIndex: 10, whiteSpace: 'nowrap', padding: '3px', borderRadius: '4px', textTransform: 'uppercase', width: '70%'
                  }}>
                  Role Name
                </TableCell>
                <TableCell
                  style={{
                    background: 'linear-gradient(to right, #033316ff, #044b3fff)', borderRadius: '5px', color: 'white',
                    fontWeight: '600', fontSize: '12px', border: '1px solid #ccc', textAlign: 'center', position: 'sticky',
                    top: 0, zIndex: 10, whiteSpace: 'nowrap', padding: '3px', borderRadius: '4px', textTransform: 'uppercase'
                  }}>

                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody sx={{ backgroundColor: 'white' }}>
              {data.map((item, index) => (
                <TableRow key={item.Id} className={item.IsActive ? '' : 'inactiveRow'}
                  sx={{
                    '&:hover': { backgroundColor: '#F1E7E7' },
                    transition: 'background-color 0.3s ease-in-out'
                  }}
                >
                  <TableCell className='table-header-cell.child' sx={{ padding: '3px' }}>{index + 1}</TableCell>
                  <TableCell className='table-header-cell.child' sx={{ padding: '3px', width: '70%' }}>{item.Name}</TableCell>
                  <TableCell className='table-header-cell.child' sx={{ padding: '3px', textAlign: 'right' }}>
                    {hasEditAdministrationPermission && (
                      <Link to={`/roleDetail/${item.Id}`}>
                        <IconButton color="primary">
                          <EditIcon />
                        </IconButton>
                      </Link>
                    )}
                    {hasDeleteAdministrationPermission && (
                      <IconButton onClick={() => (item.IsActive ? openConfirmDialog(item.Id) : handleActivate(item.Id))} color="error">
                        {item.IsActive ? <DeleteIcon /> : <ActivateIcon style={{ color: 'darkolivegreen', height: '22px' }} />}
                      </IconButton>
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
            {/* Delete confirmation dialog */}
            <Dialog
              open={confirmDialogOpen}
              onClose={closeConfirmDialog}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  Are you sure you want to delete this record?
                </DialogContentText>
              </DialogContent>

              <DialogActions>
                <button onClick={closeConfirmDialog} className="bg-red-600 text-white border border-red-600 rounded px-4 py-2 mr-2">
                  Cancel
                </button>
                <button onClick={handleDelete} className="bg-green-600 text-white border border-green-600 rounded px-4 py-2">
                  Confirm
                </button>
              </DialogActions>
            </Dialog>
          </Table>
        </TableContainer>
      </div>
      <div className="watermark">
        <CopyrightIcon /><b style={{ fontFamily: 'Script Bold Italic' }}>EFFTABS SOLUTIONS LLP</b>
      </div>
    </div>

  );
}

export default RoleIndex;

